<template>
	<div class="callout-history">
		<el-descriptions :column="1" class="callout-history__item" v-for="(data,data_index) in list" :key="data_index">
			<el-descriptions-item :label="item.label" v-for="(item,index) in column" :key="index">
				<span v-if="item.prop == 'isFinish'">{{data[item.prop] == 0 ? '否' : '是'}}</span>
				<span v-else-if="item.prop == 'processResult'">{{resultObj[data[item.prop]]}}</span>
				<span v-else>{{data[item.prop] || '--'}}</span>
			</el-descriptions-item>
		</el-descriptions>
		<el-pagination
			@current-change="handleCurrentChange"
			layout="total, prev, pager, next"
			:total="total"
			:page-size="listQuery.pageSize"
			:pager-count="5">
		</el-pagination>
	</div>
</template>

<script>
	export default {
		props:['custId'],
		data() {
			return {
				list: [],
				column:[],
				origin_column:[
					{ label: '执行坐席', prop: 'userAccount' },
					{ label: '任务状态', prop: 'taskStatusName'},
					{ label: '任务备注', prop: 'taskRemarks' },
					{ label: '是否完成', prop: 'isFinish',render:(h,scope) =>{return <span>{scope.row.isFinish == 1 ? '是' :'否'}</span>}},
					{ label: '上一次外呼时间', prop: 'lastObTime' },
				],
				im_column:[
					{ label: '外呼日期时间', prop: 'lastObTime' },
					{ label: '外呼人员', prop: 'userAccount' },
					{ label: '外呼结果', prop: 'taskStatusName'},
					{ label: '拒绝原因', prop: 'subTaskStatus' },
					{ label: '处理结果', prop: 'processResult',render:(h,scope) =>{return <span>{resultObj[scope.row.processResult]}</span>}},
					{ label: '任务备注', prop: 'taskRemarks' },
					{ label: '任务ID', prop: 'taskId' },
				],
				total:0,
				listQuery:{
					pageSize:10,
					pageNumber:1,
					brandIdentify:'',
					custId:''
				},
				brandName:process.env.VUE_APP_BRANDNAME,
				resultObj: {
					'1': '下发门店',
					'2': '下发孵化',
					'3': '战败',
					'4': '无效',
					'5': '继续外呼',
					'6': '已取消',
				}
			}
		},
		methods: {
			getList() {
				this.listQuery.brandIdentify = this.$store.getters.userInfo.brandIdentify;
				this.listQuery.custId = this.custId;
				this.$api.getTaskBreathTaskLogList(this.listQuery).then(res => {
					if(res.errcode != 0) return;
					this.$nextTick(()=>{
						this.list = res.data;
						this.total = Number(res.total);
					})
				})
			},
			handleCurrentChange(val){
				this.listQuery.pageNumber = val;
				this.getList();
			}
		},
		mounted(){
			if(this.$store.getters.userInfo.brandIdentify == this.brandName) {
				this.column = this.im_column;
			}else {
				this.column = this.origin_column;
			}
			this.getList();
		}
	}
</script>

<style lang="scss" scoped>
	.callout-history {
		display: flex;
		flex-direction: column;
		align-items: center;
		&__item {
			::v-deep {
				.el-descriptions__body {
					background-color: #F6F7F9;
					padding: 10px;
					margin-top: 10px;
				}
			}
		}
	}
</style>
